export const countryOptions = [
  { value: "2aec20f4-72bc-ef11-b8e8-7c1e5202f8fb", label: "United Kingdom" },
  { value: "708a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Afghanistan" },
  { value: "728a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Albania" },
  { value: "748a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Algeria" },
  { value: "768a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Andorra" },
  { value: "788a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Angola" },
  { value: "7a8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Antigua and Barbuda" },
  { value: "7c8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Argentina" },
  { value: "7e8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Armenia" },
  { value: "808a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Australia" },
  { value: "828a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Austria" },
  { value: "848a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Azerbaijan" },
  { value: "868a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Bahamas" },
  { value: "888a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Bahrain" },
  { value: "8a8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Bangladesh" },
  { value: "8c8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Barbados" },
  { value: "8e8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Belarus" },
  { value: "908a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Belgium" },
  { value: "928a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Belize" },
  { value: "948a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Benin" },
  { value: "968a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Bhutan" },
  { value: "988a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Bolivia" },
  { value: "9a8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Bosnia and Herzegovina" },
  { value: "9c8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Botswana" },
  { value: "9e8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Brazil" },
  { value: "a08a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Brunei Darussalam" },
  { value: "a28a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Bulgaria" },
  { value: "a48a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Burkina Faso" },
  { value: "a68a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Burundi" },
  { value: "a88a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Cabo Verde" },
  { value: "aa8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Cambodia" },
  { value: "ac8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Cameroon" },
  { value: "ae8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Canada" },
  { value: "b08a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Central African Republic" },
  { value: "b28a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Chad" },
  { value: "b48a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Chile" },
  { value: "b68a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "China" },
  { value: "b88a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Colombia" },
  { value: "ba8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Comoros" },
  { value: "bc8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Costa Rica" },
  { value: "91fd3655-41bd-ef11-b8e8-6045bdfcb984", label: "Croatia" },
  { value: "be8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Cuba" },
  { value: "c08a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Cyprus" },
  { value: "c28a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Czech Republic" },
  { value: "c48a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Democratic Republic of the Congo" },
  { value: "c68a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Denmark" },
  { value: "c88a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Djibouti" },
  { value: "ca8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Dominica" },
  { value: "cc8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Dominican Republic" },
  { value: "ce8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Egypt" },
  { value: "d08a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "El Salvador" },
  { value: "d28a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Equatorial Guinea" },
  { value: "97612a86-41bd-ef11-b8e8-6045bdfcb984", label: "Eritrea" },
  { value: "d48a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Estonia" },
  { value: "d68a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Eswatini" },
  { value: "d88a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Ethiopia" },
  { value: "da8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Fiji" },
  { value: "dc8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Finland" },
  { value: "de8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "France" },
  { value: "e08a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Gabon" },
  { value: "e28a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Gambia" },
  { value: "e48a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Ghana" },
  { value: "e68a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Gibraltar" },
  { value: "e88a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Greece" },
  { value: "ea8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Grenada" },
  { value: "ec8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Guatemala" },
  { value: "ee8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Guinea" },
  { value: "f08a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Guinea-Bissau" },
  { value: "f28a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Guyana" },
  { value: "f48a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Haiti" },
  { value: "f68a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Honduras" },
  { value: "f88a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Hong Kong" },
  { value: "fa8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Hungary" },
  { value: "fc8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Iceland" },
  { value: "fe8a4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "India" },
  { value: "008b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Indonesia" },
  { value: "028b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Iran, Islamic Republic of" },
  { value: "048b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Iraq" },
  { value: "068b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Israel" },
  { value: "088b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Italy" },
  { value: "0a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Ivory Coast (Côte d'Ivoire)" },
  { value: "0c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Jamaica" },
  { value: "0e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Japan" },
  { value: "108b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Jordan" },
  { value: "128b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Kazakhstan" },
  { value: "148b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Kenya" },
  { value: "168b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Kiribati" },
  { value: "188b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Kuwait" },
  { value: "1a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Laos" },
  { value: "1c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Latvia" },
  { value: "1e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Lebanon" },
  { value: "208b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Lesotho" },
  { value: "228b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Liberia" },
  { value: "248b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Libya" },
  { value: "268b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Liechtenstein" },
  { value: "288b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Lithuania" },
  { value: "2a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Luxembourg" },
  { value: "2c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Madagascar" },
  { value: "2e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Malawi" },
  { value: "308b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Malaysia" },
  { value: "328b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Maldives" },
  { value: "348b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Mali" },
  { value: "368b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Malta" },
  { value: "388b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Marshall Islands" },
  { value: "3a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Mauritania" },
  { value: "3c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Mauritius" },
  { value: "3e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Mexico" },
  { value: "408b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Moldova" },
  { value: "428b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Monaco" },
  { value: "448b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Mongolia" },
  { value: "468b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Montenegro" },
  { value: "488b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Morocco" },
  { value: "4a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Mozambique" },
  { value: "4c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Myanmar" },
  { value: "4e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Namibia" },
  { value: "508b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Nauru" },
  { value: "528b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Nepal" },
  { value: "548b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Netherlands" },
  { value: "568b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "New Zealand" },
  { value: "588b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Nicaragua" },
  { value: "5a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Niger" },
  { value: "5c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Nigeria" },
  { value: "5e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "North Korea" },
  { value: "608b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Norway" },
  { value: "628b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Oman" },
  { value: "648b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Pakistan" },
  { value: "668b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Palau" },
  { value: "688b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Panama" },
  { value: "6a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Papua New Guinea" },
  { value: "6c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Paraguay" },
  { value: "6e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Peru" },
  { value: "708b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Philippines" },
  { value: "728b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Poland" },
  { value: "748b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Portugal" },
  { value: "768b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Qatar" },
  { value: "788b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Romania" },
  { value: "7a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Russia" },
  { value: "7c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Rwanda" },
  { value: "7e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Saint Kitts and Nevis" },
  { value: "808b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Saint Lucia" },
  { value: "828b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Saint Vincent and the Grenadines" },
  { value: "848b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Samoa" },
  { value: "868b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "San Marino" },
  { value: "888b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Sao Tome and Principe" },
  { value: "8a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Saudi Arabia" },
  { value: "8c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Senegal" },
  { value: "8e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Serbia" },
  { value: "908b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Seychelles" },
  { value: "928b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Sierra Leone" },
  { value: "948b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Singapore" },
  { value: "968b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Slovakia" },
  { value: "988b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Slovenia" },
  { value: "9a8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Solomon Islands" },
  { value: "9c8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Somalia" },
  { value: "9e8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "South Africa" },
  { value: "a08b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "South Sudan" },
  { value: "a28b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Spain" },
  { value: "a48b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Sri Lanka" },
  { value: "a68b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Sudan" },
  { value: "a88b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Suriname" },
  { value: "aa8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Sweden" },
  { value: "ac8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Switzerland" },
  { value: "ae8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Syria" },
  { value: "b08b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Taiwan" },
  { value: "b28b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Tajikistan" },
  { value: "b48b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Tanzania" },
  { value: "b68b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Thailand" },
  { value: "b88b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Timor-Leste" },
  { value: "ba8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Togo" },
  { value: "bc8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Tonga" },
  { value: "be8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Trinidad and Tobago" },
  { value: "c08b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Tunisia" },
  { value: "c28b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Turkey" },
  { value: "c48b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Turkmenistan" },
  { value: "c68b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Tuvalu" },
  { value: "c88b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Uganda" },
  { value: "ca8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Ukraine" },
  { value: "cc8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "United Arab Emirates" },
  { value: "ce8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "United States" },
  { value: "d08b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Uruguay" },
  { value: "d28b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Uzbekistan" },
  { value: "d48b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Vanuatu" },
  { value: "d68b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Vatican City State (Holy See)" },
  { value: "d88b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Venezuela" },
  { value: "da8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Vietnam" },
  { value: "dc8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Western Sahara" },
  { value: "de8b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Yemen" },
  { value: "e08b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Zambia" },
  { value: "e28b4a66-51bd-ef11-b8e8-000d3a0b9c3a", label: "Zimbabwe" },
];